"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _globals = require("../../../globals.js");

function _default(palette) {
  var _ref;

  return _ref = {
    palette: palette,
    display: 'inline-block',
    boxSizing: 'border-box',
    width: 'auto',
    minWidth: 'auto',
    lineHeight: 1.5,
    fontFamily: palette.fontFamily,
    paddingTop: palette.gutter + 'px',
    paddingRight: '0',
    paddingLeft: '0',
    paddingBottom: palette.gutter + 'px',
    textAlign: 'left',
    fontWeight: palette.twNormal,
    fontSize: palette.tsNormal,
    textTransform: 'none',
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: palette.transitionFunction,
    color: palette.tFilled,
    placeholder: palette.tHint,
    borderColor: palette.elDivider,
    borderStyle: 'none none solid',
    borderWidth: '1px',
    borderRadius: '0',
    background: 'transparent',
    boxShadow: 'none',
    outline: 'none'
  }, (0, _defineProperty2["default"])(_ref, _globals.STATE.HOVER, {
    color: palette.tFilled,
    placeholder: palette.tHint,
    borderColor: palette.elSecondary,
    borderStyle: 'none none solid',
    borderWidth: '2px',
    borderRadius: '0',
    background: 'transparent',
    boxShadow: 'none',
    outline: 'none'
  }), (0, _defineProperty2["default"])(_ref, _globals.STATE.FOCUS, {
    color: palette.tActive,
    placeholder: palette.tPlaceholder,
    borderColor: palette.elAccent,
    borderStyle: 'none none solid',
    borderWidth: '2px',
    borderRadius: '0',
    background: 'transparent',
    boxShadow: 'none',
    outline: 'none'
  }), (0, _defineProperty2["default"])(_ref, _globals.STATE.ERROR, {
    color: palette.tFilled,
    placeholder: palette.tHint,
    borderColor: palette.elDivider,
    borderStyle: 'none none solid',
    borderWidth: '1px',
    borderRadius: '0',
    background: 'transparent',
    boxShadow: 'none',
    outline: 'none'
  }), (0, _defineProperty2["default"])(_ref, _globals.STATE.DISABLED, {
    color: palette.tDisabled,
    placeholder: palette.tPlaceholder,
    borderColor: palette.elDivider,
    borderStyle: 'none none dotted',
    borderWidth: '2px',
    borderRadius: '0',
    background: 'transparent',
    boxShadow: 'none',
    outline: 'none'
  }), _ref;
}